import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Box, Grid, TableRow, TextField, Typography } from "@material-ui/core";
import useTabStyles from "../../styles/Tab.style";
import {
  ICIPAdminActionTypeEnum,
  ICIPAdminDispatchContext,
} from "../../../../context/ICIPAdminContext";
import { AddBusinessWithdrawPercent } from "./components/AddBusinessWithdrawPercent";
import { EditBusinessWithdrawPercent } from "./components/EditBusinessWithdrawPercent";
import BusinessWithdrawPercentService from "../../../../services/BusinessWithdrawPercentService";
import BusinessService from "../../../../services/BusinessService";

import useStyles from "../../tab-panels/business-withdraw-percents/BusinessWithdrawPercentTabPanel.style";
import TableData, {
  StyledTableCell,
  StyledTableRow,
} from "../../components/TableData";
import Paginator, { DataTypeEnum } from "../../../../models/Paginator";
import Button from "@material-ui/core/Button";
import BusinessWithdrawPercent from "../../../../models/BusinessWithdrawPercent";
import { Autocomplete } from "@material-ui/lab";

interface BusinessWithdrawPercentTabProps {}

export interface BusinessWithdrawPercentTabData {
  original: Paginator;
  filtered: Paginator;
}

export const BusinessWithdrawPercentTab = (
  props: BusinessWithdrawPercentTabProps
) => {
  const classes = useStyles();
  const tabClasses = useTabStyles(props);
  const intl = useIntl();
  // Context
  const dispatch = useContext(ICIPAdminDispatchContext);
  // State
  const [paginator, setPaginator] = useState(
    (): BusinessWithdrawPercentTabData => null
  );
  const [paginatorUsed, setPaginatorUsed] = useState((): Paginator => null);
  const [businesses, setBusinesses] = useState([]);
  const [businessPercents, setBusinessPercents] = useState((): any => []);
  const [modalType, setModalType] = useState(true);
  const [selectedPercent, setSelectedPercent] = useState(null);
  const [searchData, setSearchData] = useState({});
  const [percentages, setPercentages] = useState([]);
  const [error, setError] = useState(false);
  const [succeed, setSucceed] = useState(false);

  // Callback
  const openEditModal = (e, data) => {
    setModalType(false);

    setSelectedPercent(data);
    console.log(data);
  };

  const toggleModalType = () => {
    setModalType(!modalType);
  };

  //functions for business withdraw percent

  const loadBusinesses = () => {
    const response = BusinessService.getAllbusinesses();

    response.then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let businesses = JSON.parse(JSON.stringify(response.data.data));

        setBusinesses(businesses);
      } else {
        setBusinesses(businesses);
      }
    });
  };

  const searchPercents = (e, data) => {
    //setAnnouncementId(data.id);
    BusinessWithdrawPercentService.searchPercents(data).then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let filterResult = JSON.parse(JSON.stringify(response.data.data));

        let reqPaginator = Paginator.fromJson(
          JSON.parse(JSON.stringify(response.data.data)),
          DataTypeEnum.withdrawPercent
        );

        setPercentages(reqPaginator.items);
        setPaginator({
          original: reqPaginator,
          filtered: reqPaginator,
        });

        setPaginatorUsed(reqPaginator);
      } else {
        setError(true);
      }
    });
  };

  const handleDataChange = (name: string, value: string) => {
    let currentSearchData = { ...searchData };
    currentSearchData[name] = value;

    setSearchData(currentSearchData);
    console.log(currentSearchData);
  };

  const deletePercent = (percentageId) => {
    BusinessWithdrawPercentService.deleteBusinessPercent(percentageId).then(
      (response) => {
        if (response.isSuccess && response.data.code === 100) {
          fetchData();
          setSucceed(true);
          setTimeout(() => {
            setSucceed(false);
          }, 2000);
        } else {
          setError(true);
          setTimeout(() => {
            setError(false);
          }, 2000);
        }
      }
    );
  };

  const renderPercentTabPanel = () => {
    return (
      <>
        <Box component="div">
          <Grid item xs={12} sm={12} lg={12} className={classes.searchPanel}>
            <Autocomplete
              className={classes.searchSelect}
              id="business"
              options={businesses}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Business"
                  variant="outlined"
                  size="small"
                />
              )}
              getOptionLabel={(option) => option.company_name}
              onChange={(_event, business) => {
                handleDataChange("business", business);
              }}
            />

            <Button
              color="secondary"
              variant="contained"
              className={classes.searchButton}
              onClick={(e) => searchPercents(e, searchData)}
            >
              Search
            </Button>
          </Grid>
        </Box>
        <Box component="div">
          <TableData
            paginator={
              paginatorUsed.total !== 0
                ? {
                    total: paginatorUsed.total,
                    page: paginatorUsed.page,
                    totalPage: paginatorUsed.total_page,
                    title: "",
                    handlePrevAction:
                      paginatorUsed.prev_page !== null ? () => {} : null,
                    handleNextAction:
                      paginatorUsed.next_page !== null ? () => {} : null,
                  }
                : null
            }
            rows={renderPercentTableRows()}
            header={renderPercentTableHeader()}
          />
        </Box>
      </>
    );
  };

  const renderPercentTableRows = () => {
    return percentages.map((row, index) => {
      let businesPercentage = row as BusinessWithdrawPercent;

      return (
        <StyledTableRow key={index}>
          <StyledTableCell component="td" scope="row">
            {businesPercentage.business.company_name}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {businesPercentage.commission_percentage}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            <Button
              color="secondary"
              variant="contained"
              className={classes.subButton}
              value={businesPercentage.id}
              onClick={(e) => openEditModal(e, businesPercentage)}
            >
              Edit
            </Button>

            <Button
              color="default"
              variant="contained"
              className={classes.subButton}
              value={businesPercentage.id}
              onClick={() => {
                window.confirm("Do you want to Delete that percentage") &&
                  deletePercent(businesPercentage.id);
              }}
            >
              delete
            </Button>
          </StyledTableCell>
        </StyledTableRow>
      );
    });
  };

  const renderPercentTableHeader = () => {
    return (
      <TableRow>
        <StyledTableCell className={classes.tabsHead}>
          <FormattedMessage id="sharedScreen.business" />
        </StyledTableCell>
        <StyledTableCell className={classes.tabsHead} align="left">
          <FormattedMessage id="sharedScreen.commissionPercentage" />
        </StyledTableCell>
        <StyledTableCell className={classes.tabsHead} align="left">
          <FormattedMessage id="sharedScreen.actions" />
        </StyledTableCell>
      </TableRow>
    );
  };

  // Fetch data

  const fetchData = async () => {
    BusinessWithdrawPercentService.getAll().then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let reqPaginator = Paginator.fromJson(
          JSON.parse(JSON.stringify(response.data.data)),
          DataTypeEnum.withdrawPercent
        );

        setPaginator({
          original: reqPaginator,
          filtered: reqPaginator,
        });

        setPaginatorUsed(reqPaginator);

        setPercentages(reqPaginator.items);

        dispatch({
          type: ICIPAdminActionTypeEnum.loaded,
        });
      } else {
        dispatch({
          type: ICIPAdminActionTypeEnum.error,
          data: {
            error: intl.formatMessage({ id: "error.unknownError" }),
          },
        });
      }
    });
  };

  // Renders

  useEffect(() => {
    fetchData();
    loadBusinesses();
  }, []);

  return (
    <>
      {paginatorUsed !== null ? (
        <Box className={tabClasses.root}>
          <Box className={tabClasses.wrapper}>
            <Grid xs={12} sm={12} lg={12} container justify="flex-end">
              <Grid
                className={classes.myCard}
                alignItems="flex-start"
                item
                xs={12}
                sm={6}
                lg={6}
              >
                {modalType ? (
                  <AddBusinessWithdrawPercent
                    businesses={businesses}
                    submitCallback={fetchData}
                  />
                ) : (
                  <EditBusinessWithdrawPercent
                    businesses={businesses}
                    percentage={selectedPercent}
                    closeCallback={toggleModalType}
                    submitCallback={fetchData}
                  />
                )}
              </Grid>

              <Grid
                container
                className={classes.tabPanelCard}
                alignItems="flex-start"
                item
                xs={12}
                sm={6}
                lg={6}
              >

                <>
                  <Box component="div" className={classes.tabPanelCard}>
                    <Box component="div" className={classes.tabsPanel}>
                      <Box component="div" className={classes.wrapper}>
                        <Box component="div" className={classes.leftHeader}>
                          <Typography variant="h3" component="h3">
                            <FormattedMessage id="sharedScreen.businessPercentages" />
                          </Typography>

                          <Box component="div" className={classes.trailing}>
                            <Typography variant="h3" component="h3">
                              {`# ${paginatorUsed.total}`}
                            </Typography>
                          </Box>
                        </Box>
                        <Box component="div" className={classes.leftWrapper}>
                          {renderPercentTabPanel()}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </>
              </Grid>
            </Grid>
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};
